<div class="bo-layout">
  <app-admin-sidebar />
  <div class="bo-layout__main">
    <app-admin-header />
    <main class="bo-layout__content">
      <router-outlet />
    </main>
  </div>
</div>
